import { ArrowsUpDownIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import ChecklistDragReorder from "../../components/ChecklistDragReorder";
import DeleteModal from "../../utils/DeleteModal";
import EditItemModal from "../Jobs/EditItemModal";

const ChecklistFormSection = ({
    taskId,
    checklist,
    setCheckList,
    retrieveChecklist,
    updateChecklistItem,
    onClickRemoveChecklistItem,
}) => {
    const [openEditItem, setOpenEditItem] = useState(false);
    const [checklistToEdit, setChecklistToEdit] = useState([]);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

    const onClickEditItem = (value) => {
        setChecklistToEdit({ ...value });
        setOpenEditItem(true);
    };

    const onClickDeleteItem = (item) => {
        setDeleteTarget(item);
        setIsDeleteConfirmOpen(true);
    };

    const confirmDeleteItem = () => {
        if (!deleteTarget) return;
        onClickRemoveChecklistItem(deleteTarget.id);
        setDeleteTarget(null);
        setIsDeleteConfirmOpen(false);
    };

    return (
        <div className="px-5 py-4 space-y-5">
            {/* Edit modal */}
            <EditItemModal
                open={openEditItem}
                setOpen={setOpenEditItem}
                checklistItemToEdit={checklistToEdit}
                setChecklistItemToEdit={setChecklistToEdit}
                retrieveChecklist={retrieveChecklist}
            />

            {/* Delete confirmation modal */}
            <DeleteModal
                isModalOpen={isDeleteConfirmOpen}
                setIsModalOpen={setIsDeleteConfirmOpen}
                title="Are you sure you want to delete this item?"
                buttonText="Delete"
                onRemove={confirmDeleteItem}
            />

            {/* Checklist with drag and reorder */}
            <ChecklistDragReorder
                items={checklist}
                setItems={setCheckList}
                onUpdate={async (item) => {
                    await updateChecklistItem({
                        id: item.id,
                        task_id: taskId,
                        description: item.description,
                        links: JSON.stringify(item.links),
                        order: item.order,
                    });
                }}
                renderItem={(item, index) => (
                    <div className="flex flex-col gap-3 p-4 my-4 bg-gray-200 border rounded-lg border-slate-300">
                        <div className="flex items-start justify-between">
                            <div className="flex items-center gap-2">
                                <ArrowsUpDownIcon className="w-5 h-5 text-gray-500" />
                                <h2 className="font-medium text-gray-700 break-words">
                                    {item.description}
                                </h2>
                            </div>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={() => onClickEditItem(item)}
                                    className="p-1 rounded hover:bg-gray-200"
                                >
                                    <PencilIcon className="w-5 h-5 text-gray-600" />
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onClickDeleteItem(item);
                                    }}
                                    className="p-1 rounded hover:bg-gray-200"
                                >
                                    <TrashIcon className="w-5 h-5 text-gray-600" />
                                </button>
                            </div>
                        </div>

                        {item.links?.length > 0 && (
                            <div className="flex flex-wrap gap-2">
                                {item.links.map((link, idx) => (
                                    <a
                                        key={idx}
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 break-all hover:underline"
                                    >
                                        {link.name || link.url}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            />
        </div>
    );
};

export default ChecklistFormSection;
